<template>
    <div style="width: 100%; height: 100%">
        <div id="gallery--mixed-source" style="display: flex; flex-direction: column">
            <div v-if="displayType === 'GRID'" class="girdContainer" id="girdContainer">
                <div v-for="(item, index) in photoList" :key="index" :data-id="index"
                    @click.stop="clickPhoto(item, index)" :data-pswp-width="item.compressedWidth"
                    :data-pswp-height="item.compressedHeight" target="_blank" rel="noreferrer" class="imgWapper"
                    :style="'height:' + item.photoHeight + 'px'">
                    <van-image :src="item.photoUrlOutline" class="img" fit="cover" @error="photoError(index)"
                        :style="albumDetail.payPhotoType==='PAY_PHOTO'?'pointer-events: none;display:block;':'display:block;'" />
                    <div class="tips" v-if="photoListType != 'hot'">
                        <img v-if="item.photoTop && albumDetail.h5ShowTopTag"
                            :src="`${config.EVN.imageUrl}image_badge_top.png`"
                            style="width: 19px; height: 19px;margin-right: 3px;" />
                        <img v-if="item.showAiCorner && item.releaseType == 'BEAUTIFUL'"
                            :src="`${config.EVN.imageUrl}beautiful.png`"
                            style="width: 19px; height: 19px;margin-right: 3px;" />
                        <img v-if="item.showAiCorner && item.releaseType == 'MANUAL'"
                            :src="`${config.EVN.imageUrl}manual.png`"
                            style="width: 30px; height: 19px;margin-right: 3px;" />
                    </div>
                    <!-- <img v-if="item.photoTop" :src="`${config.EVN.imageUrl}manual.png`" style="width: 33px; height: 21px" class="tips" /> -->
                    <template v-if="albumDetail.payPhotoType==='PAY_PHOTO'">
                        <template v-if="item.payPhoto">
                            <div class="alreadyBuy">已购买</div>
                        </template>
                        <template v-else>
                            <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                                class="chose" @click.stop="choseItem(item)" />
                            <img v-if="choseEdit && item.isChecked" :src="computedResources('tick-circle-check.png')"
                                class="chose" @click.stop="choseItem(item)" />
                        </template>
                    </template>
                    <template v-else>
                        <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                            class="chose" @click.stop="choseItem(item)" />
                        <img v-if="choseEdit && item.isChecked" :src="computedResources('tick-circle-check.png')"
                            class="chose" @click.stop="choseItem(item)" />
                    </template>
                    <text v-if="debug" class="debug">{{ item.photoId }}--({{ index }})</text>
                </div>
            </div>
            <div v-if="displayType === 'TIME_LINE'" class="timelineContainer" id="timelineContainer">
                <div v-for="(item, index) in photoList" :key="index" :data-id="index"
                    @click.stop="clickPhoto(item, index)" :data-pswp-width="item.compressedWidth"
                    :data-pswp-height="item.compressedHeight" target="_blank" rel="noreferrer" class="timelineImgWapper"
                    :style="'height:' + item.photoHeight + 'px'">
                    <van-image :src="item.photoUrlDetail" fit="contain" class="img" @error="photoError(index)"
                        :style="albumDetail.payPhotoType==='PAY_PHOTO'?'pointer-events: none;':''" />
                    <div class="tips" v-if="photoListType != 'hot'">
                        <img v-if="item.photoTop && albumDetail.h5ShowTopTag"
                            :src="`${config.EVN.imageUrl}image_badge_top.png`"
                            style="width: 19px; height: 19px;margin-right: 3px;" />
                        <img v-if="item.showAiCorner && item.releaseType == 'BEAUTIFUL'"
                            :src="`${config.EVN.imageUrl}beautiful.png`"
                            style="width: 19px; height: 19px;margin-right: 3px;" />
                        <img v-if="item.showAiCorner && item.releaseType == 'MANUAL'"
                            :src="`${config.EVN.imageUrl}manual.png`"
                            style="width: 30px; height: 19px;margin-right: 3px;" />
                    </div>
                    <div class="tips" v-if="photoListType == 'hot' && index <=9" style="width: 50px; height: 50px">
                        <div style="position: relative;width: 50px; height: 50px">
                            <img src="../assets/images/hot.png"
                                style="width: 27px; height:30px;position: absolute;left: 50%;top:50%;transform:translate(-80%,-60%);" />
                            <div
                                style="color: #FEFFD3;font-size: 12px;position: absolute;left: 50%;top:50%;transform:translate(-110%,-50%);z-index: 1;">
                                {{ index<9?`0${index+1}`:`${index+1}` }} </div>
                            </div>
                        </div>
                        <template v-if="albumDetail.payPhotoType==='PAY_PHOTO'">
                            <template v-if="item.payPhoto">
                                <div class="alreadyBuy">已购买</div>
                            </template>
                            <template v-else>
                                <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                                    class="chose" @click.stop="choseItem(item)" />
                                <img v-if="choseEdit && item.isChecked"
                                    :src="computedResources('tick-circle-check.png')" class="chose"
                                    @click.stop="choseItem(item)" />
                            </template>
                        </template>
                        <template v-else>
                            <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                                class="chose" @click.stop="choseItem(item)" />
                            <img v-if="choseEdit && item.isChecked" :src="computedResources('tick-circle-check.png')"
                                class="chose" @click.stop="choseItem(item)" />
                        </template>
                    </div>
                </div>
                <div v-if="displayType === 'WATERFALL_FLOW'" class="masonry" id="masonry"
                    :style="`height:${Math.max(leftHeight, rightHeight)}px`">
                    <div v-for="(item, index) in photoList" :key="index" :data-id="index"
                        @click.stop="clickPhoto(item, index)" target="_blank" rel="noreferrer" class="masonryItem"
                        :style="`width:${width}px;height:${item.photoHeight}px;top:${item.top}px;left:${item.left}px;right:${item.right}px`">
                        <van-image fit="cover" :src="item.photoUrlOutline" class="img" :id="item.photoId"
                            @error="photoError(index)"
                            :style="albumDetail.payPhotoType==='PAY_PHOTO'?'pointer-events: none;':''" />
                        <text v-if="debug" class="debug">{{ item.photoId }}--({{ index }})</text>
                        <div class="tips" v-if="photoListType != 'hot' && photoListType != 'vote'">
                            <img v-if="item.photoTop && albumDetail.h5ShowTopTag"
                                :src="`${config.EVN.imageUrl}image_badge_top.png`"
                                style="width: 19px; height: 19px;margin-right: 3px;" />
                            <img v-if="item.showAiCorner && item.releaseType == 'BEAUTIFUL'"
                                :src="`${config.EVN.imageUrl}beautiful.png`"
                                style="width: 19px; height: 19px;margin-right: 3px;" />
                            <img v-if="item.showAiCorner && item.releaseType == 'MANUAL'"
                                :src="`${config.EVN.imageUrl}manual.png`"
                                style="width: 30px; height: 19px;margin-right: 3px;" />
                        </div>
                        <div class="tips" v-if="photoListType == 'hot' && index <=9" style="width: 50px; height: 50px">
                            <div style="position: relative;width: 50px; height: 50px">
                                <img src="../assets/images/hot.png"
                                    style="width: 27px; height:30px;position: absolute;left: 50%;top:50%;transform:translate(-80%,-60%);" />
                                <div
                                    style="color: #FEFFD3;font-size: 12px;position: absolute;left: 50%;top:50%;transform:translate(-110%,-50%);z-index: 1;">
                                    {{ index<9?`0${index+1}`:`${index+1}` }} </div>
                                </div>
                            </div>
                            <div class="tips" v-if="photoListType == 'vote'" style="width: 50px; height: 50px">
                                <div style="position: relative;width: 50px; height: 50px">
                                    <img v-if="index === 0" src="../assets/images/photoList/vote_one.png"
                                        style="width: 32px; height:35px;position: absolute;left: 50%;top:50%;transform:translate(-80%,-60%);" />
                                    <img v-if="index === 1" src="../assets/images/photoList/vote_two.png"
                                        style="width: 32px; height:35px;position: absolute;left: 50%;top:50%;transform:translate(-80%,-60%);" />
                                    <img v-if="index === 2" src="../assets/images/photoList/vote_three.png"
                                        style="width: 32px; height:35px;position: absolute;left: 50%;top:50%;transform:translate(-80%,-60%);" />
                                    <div v-if="index > 2"
                                        style="color: #fff;font-size: 12px;position: absolute;left:0;top:0;z-index: 1;width: 40px;line-height: 22px;border-radius: 11px;background-color: rgba(0,0,0,0.5);text-align: center;font-size: 13px;">
                                        {{ `NO.${index+1}` }}
                                    </div>
                                </div>
                            </div>
                            <template v-if="albumDetail.payPhotoType==='PAY_PHOTO'">
                                <template v-if="item.payPhoto">
                                    <div class="alreadyBuy">已购买</div>
                                </template>
                                <template v-else>
                                    <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                                        class="chose" @click.stop="choseItem(item)" />
                                    <img v-if="choseEdit && item.isChecked"
                                        :src="computedResources('tick-circle-check.png')" class="chose"
                                        @click.stop="choseItem(item)" />
                                </template>
                            </template>
                            <template v-else>
                                <img v-if="choseEdit && !item.isChecked" :src="computedResources('tick-circle.png')"
                                    class="chose" @click.stop="choseItem(item)" />
                                <img v-if="choseEdit && item.isChecked"
                                    :src="computedResources('tick-circle-check.png')" class="chose"
                                    @click.stop="choseItem(item)" />
                            </template>
                        </div>
                    </div>
                    <div class="footer footer-cell" v-if="loadMore">
                        <van-loading size="18px" type="spinner" />
                        <text>{{isEnglish?'loading':'加载中'}}...</text>
                    </div>
                    <div class="footer footer-cell" v-else style="margin-bottom: 20px;">
                        <divider>{{isEnglish?'no more data':'没有更多数据啦'}}~</divider>
                    </div>
                </div>
                <div class="fc light-box"
                    :style="`opacity:${lightboxOpacity};${lightboxOpacity > 0 ? '' : 'pointer-events: none;'}`">
                    <div id="pswp-ctn">
                        <!-- <van-loading v-show="loadingDetailImg" size="24px" type="spinner" class="loadDetailImg"/> -->
                        <img v-show="loadingDetailImg" src="../assets/images/photoDetails/loadImg.gif" alt=""
                            class="loadDetailImg" />
                        <div class="headerContainer">
                            <img v-if="showReturnIcon" @click="closeLightBox" :src="computedResources('return.png')"
                                style="width: 24px; height: 24px" />
                            <div>{{ index + 1 }}/{{ totalCount }}</div>
                            <img v-if="originBtnText === '已展示' && !isEnglish" @click="isShowPhotoInfo"
                                :src="computedResources('info_circle.png')" style="width: 24px; height: 24px" />
                            <img v-if="originBtnText === 'Displayed'  && isEnglish" @click="isShowPhotoInfo"
                                :src="computedResources('info_circle.png')" style="width: 24px; height: 24px" />
                        </div>
                        <template v-if="!showPurenessPhoto">
                            <div class="fc photo-info" v-if="!isEnglish && photoDetail && showPhotoInfo && originBtnText === '已展示'">
                                <div>图片名称：{{ photoDetail.fileName }}</div>
                                <div>图片大小：{{ photoLength }}</div>
                                <div>图片大分辨率：{{ photoSize }}</div>
                                <template v-if="photoDetail.exifInfo">
                                    <div>器材：{{ photoDetail.exifInfo.model.includes(photoDetail.exifInfo.make) ?
                                        photoDetail.exifInfo.model :photoDetail.exifInfo.model +
                                        photoDetail.exifInfo.make}}</div>
                                    <div>焦距：{{photoDetail?.exifInfo?.focalLength? photoDetail?.exifInfo?.focalLength +
                                        'mm': '未知'}}</div>
                                    <div>光圈：{{photoDetail?.exifInfo?.fNumber ? 'f/' + photoDetail?.exifInfo?.fNumber :
                                        '未知'}}</div>
                                    <div>ISO：{{ photoDetail?.exifInfo?.iso ? photoDetail?.exifInfo?.iso : '未知' }}</div>
                                    <div>快门速度：{{photoDetail?.exifInfo?.exposureTime?
                                        photoDetail?.exifInfo?.exposureTime: '未知'}}</div>
                                    <div>曝光：{{photoDetail?.exifInfo?.exposureProgram?
                                        getExposureProgram(Number(photoDetail?.exifInfo?.exposureProgram)): '未知'}}</div>
                                </template>
                                <div v-if="photoDetail.captureTime">图片拍摄时间：{{ photoDetail.captureTime }}</div>
                            </div>
                            <div class="fc photo-info"
                                v-if="isEnglish && photoDetail && showPhotoInfo && originBtnText === 'Displayed'">
                                <div>Name：{{ photoDetail.fileName }}</div>
                                <div>Size：{{ photoLength }}</div>
                                <div>Resolution:{{ photoSize }}</div>
                                <template v-if="photoDetail.exifInfo">
                                    <div>Equipment：{{ photoDetail.exifInfo.model.includes(photoDetail.exifInfo.make) ?
                                        photoDetail.exifInfo.model : photoDetail.exifInfo.model +
                                        photoDetail.exifInfo.make }}</div>
                                    <div>Focal：{{ photoDetail?.exifInfo?.focalLength ?
                                        photoDetail?.exifInfo?.focalLength +
                                        'mm' : '未知' }}</div>
                                    <div>Aperture：{{ photoDetail?.exifInfo?.fNumber ? 'f/' +
                                        photoDetail?.exifInfo?.fNumber :
                                        '未知' }}</div>
                                    <div>ISO：{{ photoDetail?.exifInfo?.iso ? photoDetail?.exifInfo?.iso : 'none' }}
                                    </div>
                                    <div>Speed：{{ photoDetail?.exifInfo?.exposureTime ?
                                        photoDetail?.exifInfo?.exposureTime : 'none' }}</div>
                                    <div>Exposure：{{ photoDetail?.exifInfo?.exposureProgram ?
                                        getExposureProgram(Number(photoDetail?.exifInfo?.exposureProgram)) : 'none' }}
                                    </div>
                                </template>
                                <div v-if="photoDetail.captureTime">CaptureTime：{{ photoDetail.captureTime }}</div>
                            </div>
                            <div class="userHome fr ac" @click="toUserHome"
                                v-if="photoDetail && photoDetail.photoUserHomeId">
                                <div>摄影</div>
                                <img class="userAvatar" :src="photoDetail && photoDetail.photoUserHomeAvatar" alt="" />
                                <div>{{ photoDetail && photoDetail.photoUserHomeNickname }}</div>
                            </div>
                            <div class="fr ac avatarBox" v-if="avatarList.length > 0">
                                <div class="fr ac faceBox-album" v-if="avatarList.length > 3 && !showAllFace"
                                    :style="avatarList.length > 3 ? 'border-radius: 8px 0 0 8px;' : 'border-radius: 8px'">
                                    <img v-for="(item, index) in avatarList.slice(0, 3)" :key="index" :src="item"
                                        class="face" @click="clickFace(index)" />
                                </div>
                                <div class="fr ac faceBox-album" v-else
                                    :style="avatarList.length > 3 ? 'border-radius: 8px 0 0 8px;' : 'border-radius: 8px'">
                                    <img v-for="(item, index) in avatarList" :key="index" :src="item" class="face"
                                        @click="clickFace(index)" />
                                </div>
                                <img @click="isShowAllFace" v-if="avatarList.length > 3"
                                    :src="computedResources(showAllFace ? 'arrow_left.png' : 'arrow_right.png')"
                                    style="width: 31px; height: 48px" />
                            </div>
                            <div v-if="avatarList.length > 0" class="fr ac jc faceTips">{{ isEnglish?'Click on the avatar to view photos related to TA':'点击头像查看与TA相关的照片' }}</div>
                            <div class="fr ac jsb bottom-btn-container">
                                <div class="fr ac jsb" style="width: 100%">
                                    <div v-if="(albumDetail.payPhotoType!=='PAY_PHOTO'  && canDownload) || (albumDetail.payPhotoType === 'PAY_PHOTO' && photoDetail?.payPhoto)"
                                        @click="clickOrigin" class="origin_btn_text fr ac jc">{{ originBtnText }}</div>
                                    <div v-if="albumDetail.payPhotoType === 'PAY_PHOTO' && !photoDetail?.payPhoto"
                                        @click="buyPhoto" class="origin_btn_text fr ac jc">立即购买(￥{{
                                        albumDetail.photoPrice }})</div>
                                    <div class="fr ac">
                                        <div v-if="handleIsshowVote" class="fc ac iconContainer"
                                            style="margin-right: 15px" @click="handleVote">
                                            <img v-show="userVote" src="../assets/images/photoDetails/vote_done.png"
                                                class="bottom_icon" />
                                            <img v-show="!userVote" src="../assets/images/photoDetails/vote_none.png"
                                                class="bottom_icon" />
                                            <div>{{ voteCount }}</div>
                                        </div>
                                        <div v-if="albumDetail.payPhotoType === 'SELECT_PHOTO' && photoDetail?.selectPhoto"
                                            class="fc ac iconContainer" style="margin-right: 15px"
                                            @click="choosePhoto(false)">
                                            <img src="../assets/images/choose.png" class="bottom_icon" />
                                            <div>已选片</div>
                                        </div>
                                        <div v-if="albumDetail.payPhotoType === 'SELECT_PHOTO' && !photoDetail?.selectPhoto"
                                            class="fc ac iconContainer" style="margin-right: 15px"
                                            @click="choosePhoto(true)">
                                            <img src="../assets/images/unchoose.png" class="bottom_icon" />
                                            <div>未选片</div>
                                        </div>
                                        <div v-if="albumDetail.payPhotoType === 'PAY_PHOTO' ? photoDetail?.payPhoto : canDownload"
                                            class="fc ac iconContainer" style="margin-right: 15px"
                                            @click="downloadPhoto">
                                            <img :src="computedResources('download.png')" class="bottom_icon" />
                                            <div>{{isEnglish?'Download':'下载'}}</div>
                                        </div>
                                        <div class="fc ac iconContainer" style="margin-right: 15px" @click="sharePhoto">
                                            <img :src="computedResources('Share.png')" class="bottom_icon" />
                                            <div>{{isEnglish?'Share':'分享'}}</div>
                                        </div>
                                        <div class="fc ac iconContainer" v-if="canLike" @click="clickLikePhoto">
                                            <img :src="computedResources(isLiske ? 'heart_checked.png' : 'heart.png')"
                                                class="bottom_icon" />
                                            <div>{{ likeCounts }}</div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </template>
                    </div>
                </div>
                <ToastBottom :visible="showShareModal" :height="256" @close="sharePhoto">
                    <div class="shareContainer">
                        <div class="toast-title fr ac jfs">海报样式</div>
                        <div class="shareBox">
                            <div class="fc ac">
                                <div class="pluzee-item-box fc ac jc" @click="chosePoster('POSTER_1')">
                                    <img :src="computedResources('image1_rad.png')" class="pluzee-item-icon" />
                                </div>
                                <div class="pullze-item-text" style="margin-top: 4px">海报1</div>
                            </div>
                            <div class="fc ac">
                                <div class="pluzee-item-box fc ac jc" @click="chosePoster('POSTER_2')">
                                    <img :src="computedResources('image2_rad.png')" class="pluzee-item-icon" />
                                </div>
                                <div class="pullze-item-text" style="margin-top: 4px">海报2</div>
                            </div>
                        </div>
                    </div>
                </ToastBottom>
            </div>
</template>
<script lang="ts">
import type {PhotoDetailParams, PhotoListParam, PhotoOutlineProps, RequestPhotoOutlineProps, AlbumDetailProps} from '@/views/props'
import PhotoSwipeLightbox from 'photoswipe/lightbox'
import 'photoswipe/style.css'
import {defineComponent, reactive, toRefs, watchPostEffect, PropType, onMounted, onUnmounted, onActivated, onDeactivated,computed} from 'vue'
import {buildPhotoUrl, replaceErrorPhoto} from '@/utils/buildPhotoUrls'
import config from '@/config'
import {useThemeStore} from '@/store/theme'
import { getFileName, getImageInfo, getIsWxClient, computedResources, IsQQBrowser,getExposureProgram} from '@/utils'
import Cookies from 'js-cookie'
import { likePhoto, useDataPoint, useGetAlbumList, useGetAlbumPhotoDetail,addSelectPhoto,deleteSelectPhoto,vote } from '@/views/api'
import { imageUrlToCanvasImage} from '@/utils/canvas'
import {useAlbumStore} from '@/store/album'
import 'vant/es/image-preview/style'
import {useDialog} from 'naive-ui'
import {useRouter} from 'vue-router'
import ToastBottom from '../components/ToastBottom.vue'
import {Divider, showToast, Toast } from 'vant'
import {readyWxPay} from '@/utils/wxPay'

export default defineComponent({
    props: {
        photoList: {
            type: Array as PropType<PhotoOutlineProps[]>,
            default: []
        },
        choseEdit: {
            type: Boolean,
            default: false
        },
        debug: {
            type: Boolean,
            default: false
        },
        displayType: {
            type: String,
            default: ''
        },
        loadMore: {
            type: Boolean,
            default: true
        },
        totalCount: {
            type: Number,
            default: 0
        },
        needRefresh: {
            type: Boolean,
            default: false
        },
        pages: {
            type: Number,
            default: 0
        },
        albumDetail: {
            type: Object as PropType<AlbumDetailProps>,
            default: null
        },
        photoListType: {
            type: String,
            default:''
        },
        repeatLike: {
            type: Boolean,
            default: true,
            required: false
        }
    },
    emits: ['choseItem', 'buyPhoto', 'nextPage', 'refreshList'],
    components: {ToastBottom, Divider},
    setup(props, context) {
        const themeStore = useThemeStore()
        const albumStore = useAlbumStore()
        const router = useRouter()
        const dialog = useDialog()
        const state = reactive({
            photoList: props.photoList,
            lightbox: null,
            theme: themeStore.theme,
            leftHeight: 0,
            rightHeight: 0,
            width: 0,
            loadMore: props.loadMore,
            pages: props.pages,
            pageSize: albumStore.pageSize,
            index: 0,
            showShareModal: false,
            photoDetail: null,
            refreshLightbox: props.needRefresh,
            lightboxOpacity: 0,
            showPhotoInfo: false,
            isLiske: false,
            likeCounts: 0,
            originBtnText: '',
            avatarList: [],
            showAllFace: false,
            photoLength: '',
            photoSize: '',
            canDownload: true,
            canLike: true,
            showPurenessPhoto: false,
            showReturnIcon: false,
            albumDetail: props.albumDetail,
            totalCount: props.totalCount,
            buyPhotoInfo: undefined,
            voteCount: 0,
            userVote: false,
            loadingDetailImg: false,
            isEnglish:albumStore.albumId_en.includes(albumStore.albumId)
        })
        onMounted(() => {
            // console.log('onMounted')
            sessionStorage.removeItem('originList')
            createLightBox()
        })
        const createLightBox = () => {
            const options = {
                bgOpacity: 1,
                showHideAnimationType: 'fade',
                padding: {top: 60, bottom: 80, left: 0, right: 0},
                errorMsg: '图片加载失败',
                zoom: false,
                loop: false,
                close: false,
                counter: false,
                dataSource: state.photoList,
                pinchToClose: false,
                closeOnVerticalDrag: false,
                maxZoomLevel: 0.65,
                tapAction: () => {
                    state.showPurenessPhoto = !state.showPurenessPhoto
                },
                appendToEl: document.getElementById('pswp-ctn'),
                pswpModule: () => import('photoswipe')
            }
            const lightbox = new PhotoSwipeLightbox(options)
            // console.log('createLightBox--->',lightbox)
            lightbox.on('change', () => {
                // console.log('change--->',state.lightbox)
                state.refreshLightbox = false
                const index = lightbox.pswp.currIndex
                console.log('onCahnge--->', index)
                state.index = index
                getPhotoDetail()
                const imgElement = lightbox.pswp.currSlide?.content?.element;
                // 为当前图片添加模糊样式
                // imgElement.classList.add('low-res');
                const photoUrlDetail = state.photoList[index]?.photoUrlDetail;
                const photoUrlOrigin = state.photoList[index]?.photoUrlOrigin;
                let originList: string[] = []
                if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                    originList = JSON.parse(sessionStorage.getItem('originList'))
                }
                state.loadingDetailImg = true
                const highResImg = new Image();
                if (state.photoList[index]) {
                    highResImg.src = originList.includes(state.photoList[index].photoId) ? photoUrlOrigin : photoUrlDetail;
                }

                // 当高分辨率图片加载完成后，替换图片并移除模糊
                highResImg.onload = () => {
                    requestAnimationFrame(() => {
                        if (state.photoList[index] && imgElement) {
                            imgElement.src = originList.includes(state.photoList[index].photoId) ? photoUrlOrigin : photoUrlDetail;;
                        }
                        // imgElement.classList.remove('low-res');
                        // imgElement.classList.add('high-res');
                        state.loadingDetailImg = false
                    })
                };
                // 如果图片加载失败，则关闭 loadingDetailImg 状态
                highResImg.onerror = () => {
                    state.loadingDetailImg = false;
                };
            })
            lightbox.on('pointerUp', e => {
                state.refreshLightbox = false
                if (lightbox.pswp) {
                    const index = lightbox.pswp.currIndex
                    state.index = index
                    const {pageSize, pages} = state
                    // console.log('pointerUp--->', index,state.photoList.length)
                    let current = index + 1
                    let maxPageSize = Number(pages + 1) * Number(pageSize)
                    if (current > maxPageSize - 4 && current < maxPageSize - 1) {
                        // alert('触发加载下一页')
                        const params: PhotoListParam = {
                            albumId: albumStore.albumId,
                            labelId: albumStore.labelId,
                            page: pages + 1,
                            pageSize,
                            sortBy: albumStore.sortBy,
                            sortType: albumStore.sortType,
                            photoStatus: 'PUBLISHED'
                        }
                        useGetAlbumList(params).then(async (data: RequestPhotoOutlineProps) => {
                            console.log('没有添加之前photoList',state.photoList.length,lightbox.pswp.options.dataSource.length)
                            data.list.forEach((item: PhotoOutlineProps) => {
                                const clone = buildPhotoUrl(item,props.albumDetail.payPhotoType == 'PAY_PHOTO' && props.albumDetail.photoViewType == 'WATERMARK' && item.payPhoto
                                        ? []
                                        : albumStore.albumWatermark)
                                item.photoUrlOutline = clone.outLineUrl + '1'
                                item.photoUrlDetail = clone.detailUrl
                                item.photoUrlOrigin = clone.originUrl
                                item.photoUrlDownload = clone.downloadUrl

                                item.src = clone.detailUrl
                                item.width = item.releaseType == 'MANUAL' ? item.manualWidth : item.compressedWidth
                                item.height = item.releaseType == 'MANUAL' ? item.manualHeight : item.compressedHeight
                                lightbox.pswp.options.dataSource.push(item)
                            })
                            // state.photoList = state.photoList.concat(data.list)  
                            state.pages = pages + 1
                            console.log('加载下一页后index',lightbox.pswp.currIndex,'data.list',data.list.length,'state.listLength',state.photoList.length,'dataSource.length=',lightbox.pswp.options.dataSource.length)
                            context.emit('nextPage', pages + 1)
                        })
                    }
                }
            })
            lightbox.on('bindEvents', () => {
                state.showReturnIcon = true
            })
            lightbox.on('contentLoadImage', ({ content, isLazy }) => {
                // console.log('contentLoadImage--->', content.data)
                // content.data.src = content.data.src.replace('_500','_1600')
                if (props.albumDetail.payPhotoType == 'PAY_PHOTO' && !content.data.payPhoto) {
                    content.element.style.pointerEvents = 'none'
                }
            });
            lightbox.init()
            state.lightbox = lightbox
            // 手势滑动关闭图片详情页
            history.pushState(null, null, location.href);
            window.addEventListener("popstate", handleGestureLightBox);
        }
        watchPostEffect(() => {
            state.pages = props.pages
        })
        watchPostEffect(() => {
            state.albumDetail = props.albumDetail
        })
        watchPostEffect(() => {
            console.log('watchPostEffect--displayType',props.photoList.length)
            state.photoList = props.photoList
        })
        watchPostEffect(() => {
            state.totalCount = props.totalCount
        })
        watchPostEffect(() => {
            console.log('watchPostEffect')
            state.loadMore = props.loadMore
            state.refreshLightbox = props.needRefresh
            if (props.displayType === 'TIME_LINE') {
                const container = document.getElementById('timelineContainer')
                if (container) {
                    const width = container.clientWidth
                    const clone = [...state.photoList]
                    clone.forEach(i => {
                        i.photoHeight = (computedPhotoType(i).height * width) / computedPhotoType(i).width
                    })
                    // console.log('计算TIME_LINE图片高度')
                    state.photoList = clone
                }
            } else if (props.displayType === 'WATERFALL_FLOW') {
                state.leftHeight = 0
                state.rightHeight = 0
                listFormat()
            } else if (props.displayType === 'GRID') {
                const container = document.getElementById('girdContainer')
                if (container) {
                    const width = container.clientWidth / 3
                    const clone = [...state.photoList]
                    clone.forEach(i => {
                        i.photoHeight = width
                    })
                    // console.log('计算GRID图片高度')
                    state.photoList = clone
                }
            }
        })

        const listFormat = () => {
            // 获取使用屏幕宽度
            const width = document.getElementById('gallery--mixed-source')?.clientWidth || Number(localStorage.getItem('containerWidth'))
            // console.log('展示列表 width', document.getElementById('gallery--mixed-source')?.clientWidth, Number(localStorage.getItem('containerWidth')))
            localStorage.setItem('containerWidth', width.toString())
            state.width = width / 2 - 3
            let {leftHeight, rightHeight} = state
            const clone = [...state.photoList]
            clone.forEach(i => {
                delete i.top
                delete i.left
            })
            clone.forEach(async (i, index) => {
                i.photoWidth = state.width
                if (i.width === 0 || i.height === 0) {
                    const {width, height} = await getImageInfo(i.photoUrlOutline)
                    i.width = width
                    i.height = height
                    i.beautifulWidth = width
                    i.beautifulHeight = height
                    i.manualWidth = width
                    i.manualHeight = height
                }
                i.photoHeight = (computedPhotoType(i).height * state.width) / computedPhotoType(i).width
                if (i.photoHeight > 1.25 * width) i.photoHeight = 1.25 * width
                if (leftHeight < rightHeight) {
                    i.left = 0
                    i.top = leftHeight
                    leftHeight = i.photoHeight + leftHeight + 5
                } else if (leftHeight > rightHeight) {
                    i.right = 0
                    i.top = rightHeight
                    rightHeight = i.photoHeight + rightHeight + 5
                } else {
                    i.left = 0
                    i.top = leftHeight
                    leftHeight = i.photoHeight + leftHeight + 5
                }
            })
            // state.photoList = clone
            state.leftHeight = leftHeight
            state.rightHeight = rightHeight
        }

        const computedPhotoType = item => {
            let width: number = 0
            let height: number = 0
            let url: string = `${albumStore.cndUrl}${config.EVN.env}/${item.albumId}/`
            const size = '_1600/'
            switch (item.releaseType) {
                case 'ORIGIN':
                    width = item.compressedWidth
                    height = item.compressedHeight
                    url+='compress' + size +item.photoId + '.jpg?t=' + item.beautifulTime
                    break
                case 'COMPRESS':
                    width = item.compressedWidth
                    height = item.compressedHeight
                    url+='compress' + size + item.photoId + '.jpg?t=' + item.beautifulTime
                    break
                case 'BEAUTIFUL':
                    width = item.beautifulWidth
                    height = item.beautifulHeight
                    url+='beautiful' + size + item.photoId + '.jpg?t=' + item.beautifulTime
                    break
                case 'MANUAL':
                    width = item.manualWidth
                    height = item.manualHeight
                    url+='manual' + size + item.photoId + '.jpg?t=' + item.beautifulTime
                    break
            }
            return {width, height,url}
        }

        const choseItem = current => {
            context.emit('choseItem', current.photoId)
        }
        const clickPhoto = (item, index) => {
            if (props.albumDetail.payPhotoType == 'PAY_PHOTO' && !props.albumDetail.payViewPhotoDetail && !item.payPhoto) {
                context.emit('buyPhoto', item)
            } else {
                if (item.from == 'ALBUM' && props.albumDetail.payPhotoType == 'PAY_PHOTO' && !props.albumDetail.payViewPhotoDetail && item.payPhoto) {
                    state.photoList = [item]
                    index = 0
                    state.totalCount = 1
                    state.buyPhotoInfo = item
                } else {
                    state.buyPhotoInfo = state.photoList[index]
                }
                createLightBox()
                state.lightboxOpacity = 1
                state.lightbox.loadAndOpen(index)
            }
        }
        const computedPhotoSize = () => {
            let length = 0
            let size = ''
            if (state.photoDetail) {
                switch (state.photoDetail?.releaseType) {
                    case 'BEAUTIFUL':
                        length = state.photoDetail.beautifulLength
                        size = `${state.photoDetail.beautifulWidth} * ${state.photoDetail.beautifulHeight}`
                        break
                    case 'MANUAL':
                        length = state.photoDetail.manualLength
                        size = `${state.photoDetail.manualWidth} * ${state.photoDetail.manualHeight}`
                        break
                    case 'ORIGIN':
                        length = state.photoDetail.compressLength
                        size = `${state.photoDetail.compressedWidth} * ${state.photoDetail.compressedHeight}`
                        break
                    case 'COMPRESS':
                        length = state.photoDetail.compressLength
                        size = `${state.photoDetail.compressedWidth} * ${state.photoDetail.compressedHeight}`
                        break
                }
            }
            return {
                length: `${Math.ceil((length / 1024 / 1024) * 10) / 10}MB`,
                size
            }
        }
        const getPersonAvatar = (faces, url, width) => {
            let list = []
            let date = new Date().getTime()
            const proportion = width / 1600;
            const scale = 1.5;
            faces.forEach(async i => {
                let left = i.bbox.left / proportion;
                let right = i.bbox.right / proportion;
                let top = i.bbox.top / proportion;
                let bottom = i.bbox.bottom / proportion;

                let w = (right - left) * scale;
                let h = (bottom - top) * scale;
                let x = left - (w - (right - left)) / 2;
                let y = top - (h - (bottom - top)) / 2;
                list.push(imageUrlToCanvasImage(url, { x, y, w, h }))
            });
            Promise.all(list).then(res => {
                console.log(`canvas画完耗时:${new Date().getTime() - date}`)
                state.avatarList = res  
            })
        }

        const getPhotoDetail = () => {
            const { albumId } = albumStore
            const list = state.lightbox?.pswp?.options?.dataSource || []
            let photoId = ''
            if (state.buyPhotoInfo && state.buyPhotoInfo.from == 'ALBUM' && props.albumDetail.payPhotoType == "PAY_PHOTO" && !props.albumDetail.payViewPhotoDetail && state.buyPhotoInfo.payPhoto) {
                photoId = state.buyPhotoInfo.photoId
            } else {
                photoId = list[state.index]?.photoId
            }
            if (!photoId || !albumId) return
            const params: PhotoDetailParams = {
                albumId,
                photoId,
                isAllowGet: true,
                openId: albumStore.openId
            }
            useGetAlbumPhotoDetail(params).then(res => {
                // console.log('596===>', res)
                state.photoDetail = res
                state.likeCounts = res?.likeCounts || 0
                state.voteCount = res?.voteCount || 0
                state.userVote = res?.userVote || false
                // 判断是否有人脸
                if (res?.faces && res?.faces.length > 0) {
                    const {width} = computedPhotoType(res)
                    const url = list[state.index]?.photoUrlDetail
                    // console.log(state.index,state.photoList.length)
                    getPersonAvatar(res.faces,url,width)
                } else {
                    state.avatarList = []
                }
                let likeList: string[] = []
                if (JSON.parse(localStorage.getItem('likeList')) !== null) {
                    likeList = JSON.parse(localStorage.getItem('likeList'))
                }
                state.isLiske = likeList.includes(photoId)
                let originList: string[] = []
                if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                    originList = JSON.parse(sessionStorage.getItem('originList'))
                }
                if(state.isEnglish){
                    state.originBtnText = originList.includes(photoId) ? 'Displayed' : `Larger`
                }else{
                    state.originBtnText = originList.includes(photoId) ? '已展示' : `查看大图`
                }
                state.photoLength = computedPhotoSize().length
                state.photoSize = computedPhotoSize().size
                state.canDownload = res?.canDownload || false
                state.canLike = res.canLike
            })
        }
        const clickOrigin = async () => {
            if(state.isEnglish){
                if (state.originBtnText == 'Displayed') {
                    return;
                }
            }else{
                if (state.originBtnText == '已展示') {
                    return;
                }
            }
            if (state.lightbox) {
                const list = state.lightbox.pswp?.options?.dataSource || []
                const index = state.lightbox?.pswp?.currIndex
                let photoId = ''
                let photoUrlOrigin = ''
                if (state.buyPhotoInfo && state.buyPhotoInfo.from == 'ALBUM' && props.albumDetail.payPhotoType == 'PAY_PHOTO' && !props.albumDetail.payViewPhotoDetail && state.buyPhotoInfo.payPhoto) {
                    photoId = state.buyPhotoInfo.photoId
                    photoUrlOrigin = state.buyPhotoInfo.photoUrlOrigin
                } else {
                    photoId = list[state.index]?.photoId
                    photoUrlOrigin = list[state.index]?.photoUrlOrigin
                }
                if (!photoId) return
                let originList: string[] = []
                if (JSON.parse(sessionStorage.getItem('originList')) !== null) {
                    originList = JSON.parse(sessionStorage.getItem('originList'))
                }
                if (!originList.includes(photoId)) {
                    originList.push(photoId)
                    sessionStorage.setItem('originList', JSON.stringify(originList))
                }
                const url = photoUrlOrigin
                list[index].src = url
                if (state.lightbox.pswp) {
                    state.lightbox.pswp.options.dataSource[index].src = url
                    state.lightbox.pswp.refreshSlideContent(state.lightbox.pswp?.currSlide?.index)
                }
                state.originBtnText = state.isEnglish?'Displayed':'已展示'
            }
        }
        const clickLikePhoto = async () => {
            // console.log('clickLikePhoto ==>', props.repeatLike)
            const list = state.lightbox?.pswp?.options?.dataSource || []
            const index = state.lightbox?.pswp?.currIndex
            const albumId = list[index]?.albumId
            const photoId = list[index]?.photoId
            if (!photoId || !albumId) return
            const data = {albumId, photoId}
            // let likeList: string[] = []
            // if (JSON.parse(localStorage.getItem('likeList')) !== null) {
            //     likeList = JSON.parse(localStorage.getItem('likeList'))
            // }
            const likeList: string[] = JSON.parse(localStorage.getItem('likeList')) || []
            const copyList = JSON.parse(JSON.stringify(likeList))
            // console.log('likeList ====>',JSON.parse(JSON.stringify(likeList)))
            if (!props.repeatLike && likeList.includes(photoId)) {
                showToast('您已点过赞了！')
                return
            }
            if (!likeList.includes(photoId)) {
                likeList.push(photoId)
                localStorage.setItem('likeList', JSON.stringify(likeList))
            }
            await likePhoto(data)
            state.isLiske = true
            state.likeCounts = state.likeCounts + 1
        }
        const downloadPhoto = async () => {
            const list = state.lightbox?.pswp?.options?.dataSource || []
            const index = state.lightbox?.pswp?.currIndex
            if (getIsWxClient()) {
                dialog.warning({
                    title: '    ',
                    showIcon: false,
                    closable: false,
                    content: '请点击下方“查看大图”按钮后长按保存图片',
                    positiveText: '确定'
                })
            } else {
                const RNPostData = localStorage.getItem('RNPostData')
                let platform
                if (RNPostData) {
                    platform = JSON.parse(RNPostData).platform
                }

                const url = list[index].photoUrlDownload
                console.log(url)
                if (platform === 'RN_IOS') {
                    const compareUrl = url.slice().toUpperCase()
                    if (compareUrl.includes('.HEIC')) {
                        alert('HEIC图片格式请在浏览器下载')
                    } else {
                        const clickParam = {
                            event: 'downloadPhoto',
                            data: url
                        }
                        // alert(JSON.stringify(clickParam))
                        window.ReactNativeWebView.postMessage(JSON.stringify(clickParam))
                    }
                } else if (platform === 'RN_ANDROID') {
                    window.open(url)
                } else {
                    if (IsQQBrowser()) {
                        showToast('长按保存图片')
                    } else {
                        const eleLink = document.createElement('a')
                        let fileName
                        const suffix = getFileName(url).split('.')[1].toUpperCase()
                        if (suffix === 'HEIC') {
                            fileName = getFileName(url).split('.')[0] + '.jpg'
                        } else {
                            fileName = getFileName(url)
                        }
                        eleLink.download = fileName
                        eleLink.href = url
                        eleLink.click()
                        eleLink.remove()
                    }
                }
            }
        }
        const sharePhoto = () => {
            // state.showShareModal = !state.showShareModal
            // 单张图的分享默认长图样式
            chosePoster('POSTER_4')
        }
        const chosePoster = type => {
            const list = state.lightbox?.pswp?.options?.dataSource || []
            if (state?.lightbox?.pswp) {
                state.lightbox.pswp.close()
            }
            state.lightboxOpacity = 0
            state.showShareModal = false
            const shareParasm = {
                photoUrl: list[state.index].photoUrlDetail,
                type
            }
            localStorage.setItem('sharePosterParasm', JSON.stringify(shareParasm))
            router.push('/sharePoster?source=albumview-pic')
        }
        const isShowPhotoInfo = () => {
            state.showPhotoInfo = !state.showPhotoInfo
        }
        const closeLightBox = () => {
            state.lightboxOpacity = 0
            state.photoList = props.photoList
            if (state.lightbox) {
                console.log('调用destroy', new Date().getTime())
                state.lightbox.destroy()
                state.lightbox = null
                state.loadingDetailImg = false
            }
            window.removeEventListener("popstate", handleGestureLightBox);
        }
        const isShowAllFace = () => {
            state.showAllFace = !state.showAllFace
        }
        const clickFace = i => {
            if (state.lightbox.pswp) {
                state.lightbox.pswp.close()
            }
            state.lightboxOpacity = 0
            const {photoId,releaseType} = state.photoDetail
            router.push({path: '/faceResult', query: {id: photoId, faceIndex: i,releaseType}})
        }
        const toUserHome = () => {
            localStorage.setItem('userCode', state.photoDetail.photoUserHomeId)
            router.push('/userHome')
        }
        // 检查图片出现错误
        const photoError = (index: number) => {
            const clone = state.photoList
            // clone[index].photoUrlDetail = replaceErrorPhoto(clone[index].photoUrlDetail)
            // clone[index].photoUrlDownload = replaceErrorPhoto(clone[index].photoUrlDownload)
            // clone[index].photoUrlOrigin = replaceErrorPhoto(clone[index].photoUrlOrigin)
            // clone[index].photoUrlOutline = replaceErrorPhoto(clone[index].photoUrlOutline)
            // clone[index].src = replaceErrorPhoto(clone[index].src)
            state.photoList = clone
        }
        const buyPhoto = () => {
            if (!getIsWxClient()) {
                router.push('/openWechat')
            }
            let params = {
                albumId: state.albumDetail.id,
                openId: albumStore.openId,
                photoIdList: [state.photoDetail.photoId]
            }
            readyWxPay(params, res => {
                // 使用以上方式判断前端返回,微信团队郑重提示：res.err_msg将在用户支付成功后返回ok，但并不保证它绝对可靠。
                if (res.err_msg == 'get_brand_wcpay_request:ok') {
                    getPhotoDetail()
                    context.emit('refreshList')
                    //支付成功后的操作
                } else if (res.err_msg == 'get_brand_wcpay_request:cancel') {
                    //取消支付的操作
                    //取消支付
                } else {
                    //支付失败
                }
            })
        }
        // 选片或取消选片  flag  true 选中  false 取消选中
        const choosePhoto = (flag: boolean) => {
            const params = {
                albumId: state.albumDetail.id,
                photoId: state.photoDetail.photoId
            }
            if (flag) {
                addSelectPhoto(params).then(res => {
                    if (res) {
                        state.photoDetail.selectPhoto = true 
                    }
                })
            } else {
                deleteSelectPhoto(params).then(res => {
                      if (res) {
                        state.photoDetail.selectPhoto = false 
                    }
                })
            }
        }
        const handleGestureLightBox = () => {
            // 手势返回，关闭lightbox
            closeLightBox()
        }
        const handleIsshowVote = computed(() => {
            // 判断是否要显示投票按钮
            if (!albumStore.vote) {
                return false
            }
            const currentTimeStamp = Date.now()
            if (albumStore.voteStartTime) {
                // console.log('投票开始时间:', new Date(albumStore.voteStartTime.replace(" ", "T") + ":00").getTime())
                const startTime = new Date(albumStore.voteStartTime.replace(" ", "T") + ":00").getTime()
                if (currentTimeStamp < startTime) {
                    // 投票未开始
                    return false
                }
            }
            if (albumStore.voteEndTime) {
                // console.log('投票结束时间:', new Date(albumStore.voteEndTime.replace(" ", "T") + ":00").getTime())
                const endTime = new Date(albumStore.voteEndTime.replace(" ", "T") + ":00").getTime()
                if (currentTimeStamp > endTime) {
                    // 投票已结束
                    return false
                }
            }
            return true
        })
        const handleVote = () => {
            // 投票
            if (!getIsWxClient()) {
                router.push('/openWechat')
                return
            }

            const { albumId } = albumStore
            const list = state.lightbox?.pswp?.options?.dataSource || []
            let photoId = ''
            if (state.buyPhotoInfo && state.buyPhotoInfo.from == 'ALBUM' && props.albumDetail.payPhotoType == "PAY_PHOTO" && !props.albumDetail.payViewPhotoDetail && state.buyPhotoInfo.payPhoto) {
                photoId = state.buyPhotoInfo.photoId
            } else {
                photoId = list[state.index]?.photoId
            }
            // console.log('投票', photoId,albumId)
            console.log('投票', albumStore.openId)
            vote({
                albumId,
                photoId,
                openId:albumStore.openId,
                voteCount:1
            }).then(res => {
                // console.log('投票结果', res)
                if (res) {
                    getPhotoDetail()
                }
            }).catch(err => {
                console.log('投票失败', err)
            })
        }
        return {
            ...toRefs(state),
            config,
            choseItem,
            clickPhoto,
            clickOrigin,
            clickLikePhoto,
            downloadPhoto,
            sharePhoto,
            chosePoster,
            createLightBox,
            computedResources,
            isShowPhotoInfo,
            closeLightBox,
            isShowAllFace,
            clickFace,
            toUserHome,
            photoError,
            albumStore,
            buyPhoto,
            choosePhoto,
            handleIsshowVote,
            handleVote,
            getExposureProgram
        }
    }
})
</script>

<style>
/* 图片模糊样式 */
/* ::v-deep .low-res {
    filter: blur(1px); 
    transition: filter 0.2s ease-out;
}

::v-deep .high-res {
    filter: blur(0);
} */
.girdContainer {
    min-height: 500px;
    width: 100%;
    clear: both;
}

.girdContainer :nth-child(3n + 1) {
    margin-right: 0.5%;
}

.girdContainer :nth-child(3n + 2) {
    margin-right: 0.5%;
}

.light-box {
    width: 100%;
    height: 100%;
    background: #1a1a1a;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
}

.timelineContainer {
    min-height: 500px;
    width: 100%;
    display: flex;
    flex-direction: column;
}

.timelineImgWapper {
    width: 100%;
    position: relative;
    margin-bottom: 10px;
}

.imgWapper {
    width: 33%;
    margin-bottom: 2px;
    float: left;
}

.imgWapper_time {
    width: 100%;
    float: left;
}

.div {
    width: 100%;
    padding-bottom: 100%;
    position: relative;
    margin-bottom: 8px;
}

.img {
    width: 100%;
    height: 100%;
    position: absolute;
    animation: animation 1s;
}

@keyframes animation {
    from {
        opacity: 0;
    }

    to {
        opacity: 1;
    }
}

.tips {
    position: absolute;
    left: 5px;
    top: 5px;
    display: flex;
    align-items: center;
}

.chose {
    position: absolute;
    width: 20px;
    height: 20px;
    right: 4px;
    top: 4px;
}

.originBtn {
    width: 50%;
    height: 80px;
    position: absolute;
    bottom: 0;
    left: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
}

.downloadBtn {
    width: 50%;
    height: 80px;
    position: absolute;
    bottom: 0;
    right: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    background: #000;
}

.debug {
    position: absolute;
    font-size: 15px;
    color: #fff;
    left: 0px;
    top: 0px;
    text-shadow: 1px 2px 2px #000;
}

.masonry {
    min-height: 500px;
    width: 100%;
    position: relative;
}

.masonryItem {
    position: absolute;
}

.footer {
    display: flex;
    align-items: center;
    justify-content: center;
}

.van-popup {
    z-index: 99999999 !important;
    position: fixed;
}

.van-image-preview {
    background-color: #000 !important;
}

.n-modal-container {
    z-index: 999999 !important;
}

.headerContainer {
    /* height: 60px; */
    height: 44px;
    width: 100%;
    display: flex;
    align-items: center;
    color: #fff;
    position: absolute;
    left: 0;
    top: 0;
    padding: 0 15px;
    justify-content: space-between;
    z-index: 999999;
}

.faceBox-album {
    display: flex;
    align-items: center;
    width: 100%;
    height: 48px;
    background: #333333;
    padding-left: 12px;
    max-width: 312px;
    overflow-x: scroll;
}

.face {
    width: 32px;
    height: 32px;
    margin-right: 12px;
    border-radius: 32px;
    object-fit: cover;
}

.userAvatar {
    width: 24px;
    height: 24px;
    margin: 0 5px;
    border-radius: 24px;
    object-fit: cover;
}

.faceImg {
    width: 40px;
    height: 40px;
    border-radius: 40px;
}

.faceBox::-webkit-scrollbar {
    display: none;
}

.animation0 {
    width: 40px;
    height: 40px;
    bottom: 60px;
    right: 30px;
    position: absolute;
    animation: likeAnimation 1.2s linear;
}

.animation1 {
    width: 40px;
    height: 40px;
    bottom: 60px;
    right: 30px;
    position: absolute;
    animation: likeAnimation1 1.2s linear;
}

@keyframes likeAnimation {
    0% {
        opacity: 1;
        transform: translateX(0px) translateY(20px) scale(0.8);
    }

    20% {
        opacity: 0.8;
        transform: translateX(-20px) translateY(0px) scale(0.8);
    }

    40% {
        opacity: 0.6;
        transform: translateX(0px) translateY(-40px) scale(0.8);
    }

    60% {
        opacity: 0.4;
        transform: translateX(20px) translateY(-60px) scale(0.8);
    }

    80% {
        opacity: 0.2;
        transform: translateX(0px) translateY(-80px) scale(0.8);
    }

    100% {
        opacity: 0;
        transform: translateX(-20px) translateY(-100px) scale(0.8);
    }
}

@keyframes likeAnimation1 {
    0% {
        opacity: 1;
        transform: translateX(0px) translateY(20px) scale(0.8);
    }

    20% {
        opacity: 0.8;
        transform: translateX(20px) translateY(0px) scale(0.8);
    }

    40% {
        opacity: 0.6;
        transform: translateX(0px) translateY(-40px) scale(0.8);
    }

    60% {
        opacity: 0.4;
        transform: translateX(20px) translateY(-60px) scale(0.8);
    }

    80% {
        opacity: 0.2;
        transform: translateX(0px) translateY(-80px) scale(0.8);
    }

    100% {
        opacity: 0;
        transform: translateX(20px) translateY(-100px) scale(0.8);
    }
}

.bottom-btn-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 0 20px;
    position: fixed;
    bottom: 0;
    left: 0;
    z-index: 100001;
    width: 100%;
    height: 70px;
}

.origin_btn_text {
    height: 33px;
    width: 126px;
    color: #fff;
    border-radius: 8px;
    font-size: 12px;
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.5);
    box-sizing: border-box;
}

.bottom_btn_box {
    display: flex;
    align-items: center;
}

.bottom_icon {
    width: 20px;
    height: 20px;
}

.shareContainer {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    padding-top: 26px;
}

.modeItem {
    width: 50%;
    display: flex;
    flex-direction: column;
    align-items: center;
    font-size: 14px;
}

.shareBox {
    display: flex;
    align-items: center;
    justify-content: space-around;
    width: 100%;
    margin-top: 16px;
}

.posterIcon {
    width: 80px;
    height: 120px;
}

.iconContainer {
    font-size: 12px;
    color: #fff;
}

.pswp__bg {
    background: #1a1a1a;
}

.pswp__icn {
    opacity: 0 !important;
}

.photo-info {
    font-size: 12px;
    width: 100%;
    color: #ecedee;
    line-height: 17px;
    background: rgba(0, 0, 0, 0.4);
    position: fixed;
    z-index: 100001;
    left: 0;
    padding: 8px 24px;
    top: 50px;
}

.userHome {
    font-size: 12px;
    color: #ecedee;
    line-height: 17px;
    background: rgba(0, 0, 0, 0.5);
    border-radius: 0px 18px 18px 0px;
    height: 32px;
    position: fixed;
    z-index: 100001;
    left: 0;
    padding: 0 10px;
    top: 60px;
}

.avatarBox {
    position: fixed;
    z-index: 100001;
    right: 16px;
    bottom: 70px;
}

.faceTips {
    height: 25px;
    border-radius: 25px;
    font-size: 12px;
    color: #fff;
    line-height: 14px;
    background: #000000;
    position: fixed;
    z-index: 100001;
    right: 16px;
    bottom: 120px;
    padding: 0 10px;
}
.alreadyBuy {
    position: absolute;
    min-width: 70px;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    font-size: 12px;
    color: #fff;
    background: rgba(0, 0, 0, 0.5);
    height: 21px;
    border-radius: 13px;
    text-align: center;
    line-height: 21px;
    padding: 0 10px;
}
.pswp__img{
    object-fit: cover !important;
}
.loadDetailImg{
    position: fixed;
    left: calc(50% - 12px);
    top: calc(50vh - 12px);
    z-index: 100001;
    width: 24px;
    height: 24px;
    display: block;
}
</style>
